import { makeDoneHrPending } from "api/Pendings"
import { useMutation, useQueryClient } from "react-query"
import { toast } from "react-toastify"


export const useMakeDoneHrPending = () => {
    const queryClinet = useQueryClient();
    return useMutation(makeDoneHrPending, {
        onSuccess: () => {
            queryClinet.invalidateQueries('hrPendings');
            // queryClinet.invalidateQueries(['widgetData', 'Appointment Pendings List'])
            toast.success('Pending is done')
        },
        onError: () => {
            toast.error('Something went wrong!')
        }
    })
}